<template>
  <label :for="name" class="flex items-center justify-between cursor-pointer">
    <span v-html="title" />
    <div class="relative">
      <input @click="$emit('toggle')" :id="name" type="checkbox" :checked="checked" class="hidden" />
        <div class="transition-all duration-300 ease-in-out flex items-center w-12 h-6 border border-gray-600 rounded-full shadow-inner"
          :class="[checked ? 'justify-start' : 'justify-end ', on ? 'toggle__line' : '']">
        <div v-if="checked" class="toggle__ok pl-1">{{ on }}</div>
        <div v-else class="toggle__no pr-1">{{ off }}</div>
      </div>
      <div class="toggle__dot transition-all duration-300 ease-in-out absolute w-4 h-4 bg-white rounded-full shadow inset-y-0 left-0 m-1"></div>
    </div>
  </label>
</template>
<script>
export default {
  props: {
    name: String,
    title: String,
    on: String,
    off: String,
    checked: Boolean,
  }
}
</script>
<style>
input:checked ~ .toggle__dot {
  transform: translateX(150%);
}
input:checked ~.toggle__line {
  @apply bg-green;
}
</style>
